"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMVariableCollector = void 0;
const inversify_1 = require("inversify");
const IVMCompilerUtils_1 = require("../../../interfaces/vm-transformers/IVMCompilerUtils");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const NodeGuards_1 = require("../../../node/NodeGuards");
let VMVariableCollector = class VMVariableCollector {
    constructor(vmCompilerUtils) {
        this.vmCompilerUtils = vmCompilerUtils;
    }
    collectParameterNames(functionNode) {
        const paramNames = new Set();
        if (functionNode.params) {
            for (const param of functionNode.params) {
                if (NodeGuards_1.NodeGuards.isIdentifierNode(param)) {
                    paramNames.add(param.name);
                }
                else if (NodeGuards_1.NodeGuards.isAssignmentPatternNode(param)) {
                    if (NodeGuards_1.NodeGuards.isIdentifierNode(param.left)) {
                        paramNames.add(param.left.name);
                    }
                }
                else if (NodeGuards_1.NodeGuards.isRestElementNode(param) && NodeGuards_1.NodeGuards.isIdentifierNode(param.argument)) {
                    paramNames.add(param.argument.name);
                }
            }
        }
        return paramNames;
    }
    collectAllParameterNames(functionNode) {
        const names = new Set();
        for (const param of functionNode.params) {
            this.collectNamesFromPattern(param, names);
        }
        return names;
    }
    collectDeclaredVariables(statements) {
        const declaredVars = new Set();
        this.vmCompilerUtils.traverseStatements(statements, (stmt) => {
            if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(stmt)) {
                for (const decl of stmt.declarations) {
                    this.collectFromDeclarator(decl, declaredVars);
                }
            }
            else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(stmt) && stmt.id) {
                declaredVars.add(stmt.id.name);
            }
            else if (NodeGuards_1.NodeGuards.isClassDeclarationNode(stmt) && stmt.id) {
                declaredVars.add(stmt.id.name);
            }
            else if (NodeGuards_1.NodeGuards.isForOfStatementNode(stmt) || NodeGuards_1.NodeGuards.isForInStatementNode(stmt)) {
                if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(stmt.left)) {
                    for (const decl of stmt.left.declarations) {
                        this.collectFromDeclarator(decl, declaredVars);
                    }
                }
            }
        });
        return declaredVars;
    }
    scanForLexicalDeclarations(statements) {
        const lexicalVars = new Set();
        for (const stmt of statements) {
            if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(stmt)) {
                if (stmt.kind === 'let' || stmt.kind === 'const') {
                    for (const decl of stmt.declarations) {
                        this.collectFromDeclarator(decl, lexicalVars);
                    }
                }
            }
        }
        return lexicalVars;
    }
    collectFunctionLevelDeclaredVariables(statements) {
        const declaredVars = new Set();
        for (const stmt of statements) {
            if (NodeGuards_1.NodeGuards.isVariableDeclarationNode(stmt)) {
                for (const decl of stmt.declarations) {
                    this.collectFromDeclarator(decl, declaredVars);
                }
            }
            else if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(stmt) && stmt.id) {
                declaredVars.add(stmt.id.name);
            }
            else if (NodeGuards_1.NodeGuards.isClassDeclarationNode(stmt) && stmt.id) {
                declaredVars.add(stmt.id.name);
            }
        }
        return declaredVars;
    }
    collectFromPattern(pattern, variables) {
        if (NodeGuards_1.NodeGuards.isIdentifierNode(pattern)) {
            variables.add(pattern.name);
        }
        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(pattern)) {
            this.collectFromArrayPattern(pattern, variables);
        }
        else if (NodeGuards_1.NodeGuards.isObjectPatternNode(pattern)) {
            this.collectFromObjectPattern(pattern, variables);
        }
        else if (NodeGuards_1.NodeGuards.isAssignmentPatternNode(pattern)) {
            this.collectFromPattern(pattern.left, variables);
        }
        else if (NodeGuards_1.NodeGuards.isRestElementNode(pattern)) {
            this.collectFromPattern(pattern.argument, variables);
        }
    }
    collectFromArrayPattern(pattern, variables) {
        for (const element of pattern.elements) {
            if (element) {
                if (NodeGuards_1.NodeGuards.isRestElementNode(element)) {
                    this.collectFromPattern(element.argument, variables);
                }
                else {
                    this.collectFromPattern(element, variables);
                }
            }
        }
    }
    collectFromObjectPattern(pattern, variables) {
        for (const property of pattern.properties) {
            if (NodeGuards_1.NodeGuards.isRestElementNode(property)) {
                this.collectFromPattern(property.argument, variables);
            }
            else if (NodeGuards_1.NodeGuards.isPropertyNode(property)) {
                this.collectFromPattern(property.value, variables);
            }
        }
    }
    collectFromDeclarator(decl, variables) {
        if (NodeGuards_1.NodeGuards.isIdentifierNode(decl.id)) {
            variables.add(decl.id.name);
        }
        else if (NodeGuards_1.NodeGuards.isArrayPatternNode(decl.id) || NodeGuards_1.NodeGuards.isObjectPatternNode(decl.id)) {
            this.collectFromPattern(decl.id, variables);
        }
    }
    collectNamesFromPattern(pattern, names) {
        this.collectFromPattern(pattern, names);
    }
};
exports.VMVariableCollector = VMVariableCollector;
exports.VMVariableCollector = VMVariableCollector = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _a : Object])
], VMVariableCollector);
